
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.pdp-nav--item[href^="#"]');

  triggers.forEach(el => {
    // Accesibilidad para <p> clickeable
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');

    const go = () => {
      const hash = el.getAttribute('href');
      if (!hash || hash === '#') return;

      const target = document.querySelector(hash);
      if (!target) return;

      // Scroll suave sin cálculos
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Abre el <details> del acordeón dentro de #medidas
      const details = target.querySelector('details');
      if (details) {
        const summary = details.querySelector('summary');
        if (summary && !details.open) {
          setTimeout(() => summary.click(), 200);
        } else {
          details.open = true;
        }
        summary?.focus({ preventScroll: true });
      }

      // Actualiza el hash sin saltos extra
      window.history.replaceState(null, '', hash);
    };

    el.addEventListener('click', (e) => { e.preventDefault(); go(); });
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
    });
  });
});

